import { HttpClient } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import {Router, NavigationEnd} from '@angular/router';
import {TranslationService, WindowRef, OccEndpointsService, AuthService} from '@spartacus/core'
import {combineLatest, merge, Observable} from 'rxjs'
import {filter, switchMap, take} from 'rxjs/operators'
import { EbGlobalMessageService } from '../../features/global-message/services/eb-global-message.service'
import { EbOrderHistoryService } from "../../features/order/services/facades/eb-order-history.service";
import { EbBaseSiteService } from '../../features/site-context/services/eb-base-site.service'
import {EbCountryService} from "../../features/site-context/services/eb-country.service";
import { EbLanguageService } from '../../features/site-context/services/eb-language.service'
import {EbUserAccountService} from "../../features/user/services/eb-user-account.service";



@Component({
    selector: 'eb-no-sales-area-message',
    templateUrl: './eb-no-sales-area-message.component.html',
    standalone: false
})
export class EbNoSalesAreaMessageComponent implements OnInit {
  isForbiddenSalesArea$ : Observable<boolean>

  constructor(
    protected occEndpointsService: OccEndpointsService,
    protected http: HttpClient,
    private readonly router: Router,
    public ebBaseSiteService: EbBaseSiteService,
    protected translation: TranslationService,
    public globalMessageService: EbGlobalMessageService,
    protected languageService: EbLanguageService,
    protected winRef: WindowRef,
    protected userAccountService: EbUserAccountService,
    protected ebCountryService: EbCountryService,
    private readonly orderHistoryService: EbOrderHistoryService,
    protected authService: AuthService,
  ) {}
  ngOnInit(): void {
    merge(
      this.orderHistoryService.getOrderHistoryLoadedObservable(),
      this.ebCountryService.countryChanged$,
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)),
    )
      .pipe(
        switchMap(() => this.authService.isUserLoggedIn())
      )
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.isForbiddenSalesArea$ = this.getSalesAreaStatus();
        }
      });
  }

  ngOnDestroy(): void {
    this.ebCountryService?.countryChanged$?.unsubscribe();
  }

  getSalesAreaStatus(): Observable<boolean>{
      return this.http.get<boolean>(
        this.occEndpointsService.buildUrl( "salesArea"));
  }
  resolveMessage(): string {
    let message: string
    combineLatest([this.ebBaseSiteService.getAll(), this.languageService.getActive(), this.userAccountService.getEbActiveUserData()])
      .pipe(
        take(1),
        switchMap(([allBaseSites, activeLang, activeUser]) => {
          const defaultBaseSite = allBaseSites.find(site => site.country.isocode === activeUser.orgUnit.country.isocode)
          const allowedLanguage = defaultBaseSite.languages.find(language => language.isocode === activeLang)
          let url = this.winRef.location.href.replace(
            this.ebBaseSiteService.getCountryFromUrlWithoutFallback(),
            defaultBaseSite.country.isocode
          )
          if(!allowedLanguage){
            url = url.replace(
              "/" + activeLang,
              "/" + defaultBaseSite.defaultLanguage.isocode);
          }
          return this.translation.translate('common.noSpecificSalesArea', {
            country: `<a href="${url}">${defaultBaseSite?.country?.localizedNames?.entry.find(
              country => country?.key === activeLang
            ).value}</a>`
          })
        })
      )
      .subscribe(translation => (message = translation))
    return message
  }
}
